export default __webpack_public_path__ + "static/media/logo10.788783ec.png";